module.exports = __webpack_public_path__ + "img/bullet_0.ead7516d.svg";